import script from "./VirtualDeviceItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualDeviceItem.vue?vue&type=script&setup=true&lang=js"

import "./VirtualDeviceItem.vue?vue&type=style&index=0&id=64ead03c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64ead03c"]])

export default __exports__